import Couchdb from './Couchdb'
import CouchdbClass from './CouchdbClass'
import hasher from 'password-hash-and-salt'

const userCouchdb = new CouchdbClass({ connection: 'config', collection: 'users' })
const configCouchdb = new CouchdbClass({ connection: 'config', collection: '' })
export default {
  createIndexes () {
    return Promise.all(
      [
        Couchdb.connection('default').createIndex(['collection'], 'collection'),
        Couchdb.connection('default').createIndex(['login'], 'login'),
        Couchdb.connection('default').createIndex(['createdAt'], 'createdAt'),
        Couchdb.connection('default').createIndex(['description'], 'description'),
        Couchdb.connection('winners').createIndex(['cpf'], 'cpf'),
        Couchdb.connection('states').createIndex(['sigla'], 'sigla'),
        Couchdb.connection('states').createIndex(['nome'], 'nome'),
        Couchdb.connection('surveys').createIndex(['customerId'], 'customer._id'),
        Couchdb.connection('surveys').createIndex(['ticketId'], 'ticket._id'),
        Couchdb.connection('surveys').createIndex(['eventId'], 'eventId'),
        Couchdb.connection('surveys_docs').createIndex(['surveyId'], 'surveyId')
      ]
    )
  },

  async createViews () {
    // this.deleteViews()

    await Promise.all(
      [
        this.createFilters(),
        this.createCountersViews(),
        this.createDashboardPageViews(),
        this.createJoinViews(),
        this.createCollectionsView(),
        this.createEventsViews(),
        this.createCustomerViews(),
        this.createStocksViews(),
        this.createLampsViews(),
        this.createTicketsViews(),
        this.createDocsViews(),
        this.createSurveysViews(),
        this.createDashboardView()
      ]
    )
    // await this.startViewsIndexer()
  },

  deleteViews () {
    Couchdb.connection('default').deleteDesignView('dashboard')
    Couchdb.connection('default').deleteDesignView('dashboard-page')
    Couchdb.connection('default').deleteDesignView('customers')
    Couchdb.connection('default').deleteDesignView('tickets')
    Couchdb.connection('default').deleteDesignView('ticket-by-eventId')
    Couchdb.connection('default').deleteDesignView('join')
    Couchdb.connection('default').deleteDesignView('lamps')
    Couchdb.connection('default').deleteDesignView('stocks')
    // Couchdb.connection('default').deleteDesignView('collection')
    Couchdb.connection('default').deleteDesignView('events')
    Couchdb.connection('surveys').deleteDesignView('surveys')
    Couchdb.connection('docs').deleteDesignView('docs')
  },

  createDashboardView () {
    return Promise.all([
      Couchdb.connection('default')
        .createView('dashboard-counter-model-event-date', 'dashboard-counter-model-event-date', {
          reduce: '_sum',
          map: `function (doc) {
          if (doc.hasOwnProperty('eventId') && doc.hasOwnProperty('collection') && doc.hasOwnProperty('createdAt') && !doc.hasOwnProperty('deletedAt')) {
            if (doc.collection === 'lamps' && doc.hasOwnProperty('items')) {
                emit([doc.collection, doc.eventId, doc.createdAt], doc.items.length);
            }
            else {
              emit([doc.collection, doc.eventId, doc.createdAt], 1);
            }

            if (doc.collection === 'tickets' && doc.winner === true) {
              emit(['winning-tickets', doc.eventId, doc.createdAt], 1);
            }
          }
        }`
        })
    ])
  },

  createCountersViews () {
    const couchdbDefault = new CouchdbClass({ connection: 'default' })
    return Promise.all([
      couchdbDefault.createView(
        'counter-collection-created_at',
        'counter-collection-created_at',
        {
          reduce: '_count',
          map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\')  && !doc.hasOwnProperty(\'deletedAt\') && doc.hasOwnProperty(\'createdAt\')) {\n    emit([doc.collection, doc.createdAt], null);\n  }\n}'
        }
      ),
      Couchdb.connection('default')
        .createView('count-lamps-by-event-by-type-by-power', 'count-lamps-by-event-by-type-by-power', {
          reduce: '_sum',
          map: `function (doc) {
  if (doc.collection === 'lamps' && doc.hasOwnProperty('items') && doc.items.length > 0  && !doc.hasOwnProperty('deletedAt')) {
    doc.items.forEach(function (item) {
      if (item.hasOwnProperty('type')) {
        emit([doc.eventId, item.type, item.power], 1)
      }
    })
  }
}
      `
        }),
      Couchdb.connection('default')
        .createView('counter-events-refrigerators', 'counter-events-refrigerators', {
          reduce: '_sum',
          map: `function (doc) {
  if (doc.hasOwnProperty('collection') &&
    doc.collection === 'tickets' &&
    doc.hasOwnProperty('winner') &&
    doc.winner &&
    doc.hasOwnProperty('documentedAt') &&
    doc.documentedAt &&
    doc.documentedAt !== null  && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.eventId, 1);
  }
}`
        }),
      Couchdb.connection('default')
        .createView('counter-events-tickets', 'counter-events-tickets', {
          reduce: '_sum',
          map: `function (doc) {
  if (doc.hasOwnProperty('collection') && doc.collection === 'tickets' && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.eventId, 1);
  }
}`
        }),
      Couchdb.connection('default')
        .createView('counter-events-lamps', 'counter-events-lamps', {
          reduce: '_sum',
          map: `function (doc) {
  if (doc.hasOwnProperty('collection') && doc.collection === 'lamps' && doc.hasOwnProperty('items') && doc.items && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.eventId, doc.items.length);
  }
}`
        })
    ])
  },

  createStocksViews () {
    return Promise.all([
      Couchdb.connection('default').createView('stocks-by-id', 'stocks-by-id', {
        map: `function (doc) {
  if (doc.collection === 'stocks') {
    emit(doc._id, doc);
  }
}`
      }),
      Couchdb.connection('default')
        .createView('stocks-by-event-id', 'stocks-by-event-id', {
          map: `function (doc) {
  if (doc.collection === 'stocks' && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.eventId, doc);
  }
}`
        })
    ])
  },

  createLampsViews () {
    return Promise.all([
      Couchdb.connection('default')
        .createView('lamps-by-event', 'lamps-by-event', {
          map: `function (doc) {
  if (doc.collection === 'lamps') {
    emit(doc.eventId, doc);
  }
}`
        }),
      Couchdb.connection('default')
        .createView('lamps-by-customer-id', 'lamps-by-customer-id', {
          map: `function (doc) {
  if (doc.collection === 'lamps' && doc.customer && doc.customer.id && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.customer.id, doc);
  }
}`
        }),
      Couchdb.connection('default')
        .createView('lamps-by-customer-uc', 'lamps-by-customer-uc', {
          map: `function (doc) {
  if (doc.collection === 'lamps' && doc.customer && doc.customer.uc && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.customer.uc, doc);
  }
}`
        }),
      Couchdb.connection('default')
        .createView('count-participants-event', 'count-participants-event', {
          map: `function (doc) {\n  if (doc.hasOwnProperty('createdAt') && !doc.hasOwnProperty('deletedAt')) {\n    if (doc.hasOwnProperty('eventId') && doc.hasOwnProperty('collection') && doc.collection === 'tickets') {\n      emit([doc.eventId, doc.customerId], 1);\n    }\n    if (doc.hasOwnProperty('eventId') && doc.hasOwnProperty('customer') && doc.customer.hasOwnProperty('id') && doc.hasOwnProperty('collection') && doc.collection === 'lamps') {\n      emit([doc.eventId, doc.customer.id], 1);\n    }\n  \n  }\n}`,
          reduce: '_sum'
        })
    ])
  },

  async createSurveysViews () {
    await Couchdb.connection('surveys').createView('counters', 'surveys-by-status', {
      map: `function (doc) {
      if (!doc.hasOwnProperty('deletedAt')) {
        if (doc.status === 'FINISHED') {
          emit('FINISHED', 1);
        }
        }
      }`,
      reduce: '_sum'
    })

    await Couchdb.connection('surveys').createView('collections', 'status', {
      map: `function (doc) {
          if (doc.status && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.status, doc);
          }
        }`
    })

    await Couchdb.connection('surveys').createView('collections', 'byEvent', {
      map: `function (doc) {
            if (doc.hasOwnProperty('event') && !doc.hasOwnProperty('deletedAt')) {

          emit(doc.event._id, doc);
          }
        }`
    })

    await Couchdb.connection('surveys').createView('collections', 'byUser', {
      map: `function (doc) {\n  if (doc.hasOwnProperty('user') && doc.hasOwnProperty('status') && doc.status === 'TODO' && !doc.hasOwnProperty('deletedAt')) {\n    emit(doc.user._id, doc);\n  }\n}`
    })

    await Couchdb.connection('surveys').createView('collections', 'by-user-associated', {
      map: `function (doc) {
          if (doc.hasOwnProperty('user') && doc.user && doc.user.hasOwnProperty('_id') && doc.user._id && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.user._id, doc);
          }
        }`
    })

    await Couchdb.connection('surveys').createView('collections', 'ticket-id', {
      map: `function (doc) {
          if (doc.ticketId && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.ticketId, doc);
          }
        }`
    })

    await Couchdb.connection('surveys').createView('collections', 'customer-id', {
      map: `function (doc) {
          if (doc.customer && doc.customer._id && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.customer._id, doc);
          }
        }`
    })

    await Couchdb.connection('surveys').createView('collections', 'customer-uc', {
      map: `function (doc) {
          if (doc.customer && doc.customer.uc && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.customer.uc, doc);
          }
        }`
    })

    await Couchdb.connection('surveys').createView('collections', 'customer-cpf', {
      map: `function (doc) {
          if (doc.customer && doc.customer.cpf && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.customer.cpf, doc);
          }
        }`
    })

    await Couchdb.connection('surveys')
      .createView('counters-surveys-by-status', 'counters-surveys-by-status', {
        map: `function (doc) {
        if ( !doc.hasOwnProperty('deletedAt')) {
  if (doc.status === 'FINISHED') {
    emit('finished', 1);
  } else if (doc.status === 'TODO') {
    emit('todo', 1);
  }
  }
}`,
        reduce: '_sum'
      })
    await Couchdb.connection('surveys')
      .createView('surveys-by-event', 'surveys-by-event', {
        map: `function (doc) {
  if (doc.hasOwnProperty('event')  && !doc.hasOwnProperty('deletedAt')) {
    emit(doc.event._id, doc);
  }
}`
      })
  },

  async createCollectionsView () {
    for (let collection of ['lamps', 'customers', 'tickets', 'events', 'stocks', 'manufacturers']) {
      await Couchdb.connection('default')
        .createView(`${collection}-by-createdAt`, `${collection}-by-createdAt`, {
          map: `function (doc) {
          if (doc.collection === '${collection}' && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.createdAt, doc);
          }
        }`
        })
    }

    await Couchdb.connection('default')
      .createView(`users-by-createdAt`, `users-by-createdAt`, {
        map: 'function (doc) {\n  if (doc.hasOwnProperty(\'collection\') && doc.collection === \'users\' && (!doc.hasOwnProperty(\'inactivated\') || !doc.inactivated) && !doc.hasOwnProperty(\'deletedAt\')) {\n    emit(doc.createdAt, null);\n  }\n}',
        reduce: '_count'
      })

    for (let collection of ['lamps', 'customers', 'tickets', 'events', 'stocks', 'manufacturers', 'users']) {
      await Couchdb.connection('default')
        .createView(
          'collection',
          collection,
          { map: `function (doc) {\n  if (doc.collection === '${collection}' && !doc.hasOwnProperty('deletedAt')) {\n    emit(doc.createdAt, doc);\n  }\n}` }
        )
    }
  },

  async createJoinViews () {
    await Couchdb.connection('default').createView('event-datas', 'event-datas', {
      map:
        `function(doc) {
        if( !doc.hasOwnProperty('deletedAt')) {
            if (doc.collection === "events") {
                emit([doc._id, 0], null);
            } else if (doc.collection === "tickets") {
              emit([doc.eventId, 1], doc._id);
              if (doc.customerId) {
                emit([doc.eventId, 2], {_id: doc.customerId});
              }
              if (doc.stockId) {
                emit([doc.eventId, 3], {_id: doc.stockId});
              }
            } else if (doc.collection === 'lamps') {
              emit([doc.eventId, 4], {_id: doc._id})
            }
            }
          }`
    })
    await Couchdb.connection('default')
      .createView('join-lamps-customer', 'join-lamps-customer', {
        map: `function(doc) {
        if ( !doc.hasOwnProperty('deletedAt')) {
    if (doc.collection === "events") {
        emit([doc._id, 0], null);
    } else if (doc.collection === "lamps") {
      emit([doc.eventId, 1], doc._id);
      if (doc.customer.id) {
        emit([doc.eventId, 2], {_id: doc.customer.id});
      }
    }
    }
  }`
      })
    await Couchdb.connection('default')
      .createView('join-ticket-event-customer', 'join-ticket-event-customer', {
        map: `function(doc) {
    if (doc.collection === "tickets" && !doc.hasOwnProperty('deletedAt')) {
      emit([doc._id, 0], null);
      if (doc.eventId) {
        emit([doc._id, 1], {_id: doc.eventId});
      }
      if (doc.customerId) {
        emit([doc._id, 2], {_id: doc.customerId});
      }
      if (doc.stockId) {
        emit([doc._id, 3], {_id: doc.stockId});
      }
    }
  }`
      })
    await Couchdb.connection('default')
      .createView('join-customer-datas', 'join-customer-datas', {
        map: `function(doc) {
        if ( !doc.hasOwnProperty('deletedAt') ){
    if (doc.collection === "customers") {
      emit([doc._id, 0], {_id: doc._id});
    } else if (doc.collection === "tickets") {
      emit([doc.customerId, 1], {_id: doc._id});
      if (doc.eventId) {
        emit([doc.customerId, 2], {_id: doc.eventId});
      }
      if (doc.stockId) {
        emit([doc.customerId, 3], {_id: doc.stockId});
      }
    } else if (doc.collection === 'lamps') {
      emit([doc.customer.id, 4], {_id: doc._id})
      emit([doc.customer.id, 5], {_id: doc.eventId})
    }
    }
  }`
      })
  },

  async createDashboardPageViews () {
    await Couchdb.connection('default')
      .createView('count-customers-all', 'count-customers-all', {
        reduce: '_count',
        map:
          `function (doc) {
            if(doc.collection === "customers" && doc.hasOwnProperty('createdAt') && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.createdAt, null);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('count-tickets-alll', 'count-tickets-alll', {
        reduce: '_sum',
        map:
          `function (doc) {
            if(doc.collection === "tickets" && !doc.hasOwnProperty('deletedAt')) {
              emit(doc._id, 1);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('count-events-all', 'count-events-all', {
        reduce: '_sum',
        map:
          `function (doc) {
            if(doc.collection === "events" && !doc.hasOwnProperty('deletedAt')) {
              emit(doc._id, 1);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('count-events-direct-list-all', 'count-events-direct-list-all', {
        reduce: '_sum',
        map:
          `function (doc) {
            if (doc.directList === true && !doc.hasOwnProperty('deletedAt')) {
              emit(doc._id, 1);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('count-lamps-all', 'count-lamps-all', {
        reduce: '_sum',
        map:
          `function (doc) {
            if(doc.collection === "lamps" && !doc.hasOwnProperty('deletedAt')) {
              emit(doc._id, doc.items.length);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('count-winners-all', 'count-winners-all', {
        reduce: '_sum',
        map:
          `function (doc) {
            if(doc.collection === "tickets" && doc.documentedAt !== null && doc.winner === true && !doc.hasOwnProperty('deletedAt')){
              emit(doc._id, 1);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('count-lamps-by-event', 'count-lamps-by-event', {
        reduce: '_sum',
        map:
          `function (doc) {
            if(doc.collection === "lamps" && doc.hasOwnProperty('eventId') && doc.eventId && doc.eventId !== null && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.eventId, doc.items.length);
            }
          }`
      })
  },

  async createEventsViews () {
    await Couchdb.connection('default')
      .createView('events-winning-tickets', 'events-winning-tickets', {
        map: `function (doc) {
        if (doc.collection === 'tickets' && doc.winner === true && !doc.hasOwnProperty('deletedAt')) {
          emit(doc.eventId, doc);
        }
      }`
      })
    await Couchdb.connection('default')
      .createView('events-by-city', 'events-by-city', {
        map: `function (doc) {
        if (doc.collection === 'events' && !doc.hasOwnProperty('deletedAt')) {
          emit(doc.city, doc);
        }
      }`
      })
    await Couchdb.connection('default')
      .createView('events-count-tickets', 'events-count-tickets', {
        map: `function (doc) {
        if (doc.collection === 'tickets' && !doc.hasOwnProperty('deletedAt')) {
          emit(doc.eventId, 1);
        }
      }`,
        reduce: '_sum'
      })
    await Couchdb.connection('default')
      .createView('events-byStartDate', 'events-byStartDate', {
        map: `function (doc) {
          if (doc.collection === 'events' && doc.hasOwnProperty('startDate') && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.startDate, doc);
          }
        }`
      })
    await Couchdb.connection('default').createView('events-by-id', 'events-by-id', {
      map: `function (doc) {
          if (doc.collection === 'events' && doc.hasOwnProperty('startDate') && !doc.hasOwnProperty('deletedAt')) {
            emit(doc._id, doc);
          }
        }`
    })
  },

  async createCustomerViews () {
    await Couchdb.connection('default')
      .createView('customers-by-id', 'customers-by-id', {
        map: `function (doc) {
          if (doc.collection === 'customers' && !doc.hasOwnProperty('deletedAt')) {
            emit(doc._id, doc);
          }
        }`
      })
    await Couchdb.connection('default')
      .createView('customers-by-uc', 'customers-by-uc', {
        map: `function (doc) {
          if (doc.collection === 'customers' && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.uc, doc);
          }
        }`
      })
    await Couchdb.connection('default')
      .createView('customers-by-cpf', 'customers-by-cpf', {
        map: `function (doc) {
          if (doc.collection === 'customers' && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.cpf, doc);
          }
        }`
      })
    await Couchdb.connection('default')
      .createView('customers-by-holder', 'customers-by-holder', {
        map: `function (doc) {
          if (doc.collection === 'customers' && !doc.hasOwnProperty('deletedAt')) {
            emit(doc.holder, doc);
          }
        }`
      })
  },

  async createTicketsViews () {
    await Couchdb.connection('default')
      .createView('tickets-by-eventId-winners', 'tickets-by-eventId-winners', {
        map: `
          function (doc) {
            if (doc.collection === 'tickets' && doc.winner && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.eventId, doc);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('tickets-by-id', 'tickets-by-id', {
        map: `function (doc) {
            if (doc.collection === 'tickets' && !doc.hasOwnProperty('deletedAt')) {
              emit(doc._id, doc);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('tickets-by-eventId', 'tickets-by-eventId', {
        map: `function (doc) {
            if (doc.collection === 'tickets' && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.eventId, doc);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('tickets-associated-by-event', 'tickets-associated-by-event', {
        map: `function (doc) {
            if (doc.collection === 'tickets' && doc.surveyAssociated && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.eventId, doc);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('tickets-by-barcode', 'tickets-by-barcode', {
        map: `function (doc) {
            if (doc.collection === 'tickets' && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.barcode, doc);
            }
          }`
      })
    await Couchdb.connection('default')
      .createView('tickets-customer-id', 'tickets-customer-id', {
        map: `function (doc) {
            if (doc.collection === 'tickets' && !doc.hasOwnProperty('deletedAt')) {
              emit(doc.customerId, doc);
            }
          }`
      })
  },

  async createDocsViews () {
    await Couchdb.connection('docs')
      .createView('docs-by-reference-id', 'docs-by-reference-id', {
        map: `function (doc) {
        if ( !doc.hasOwnProperty('deletedAt') ) {

          emit(doc.referenceId, doc);
          }
        }`
      })
  },

  async createFilters () {
    const collections = ['customers', 'events', 'lamps', 'manufacturers', 'roles', 'states', 'stocks', 'tickets', 'users']
    let filters = {}
    for (let collection of collections) {
      filters[collection] = `function (doc, req) { \n if (doc.collection === '${collection}' && !doc.hasOwnProperty('deletedAt')) { \n return true \n } \n return false \n }`
    }
    await Couchdb.connection('default').createFilters('collection', filters)
  },

  async createAdminUser () {
    await userCouchdb.where('login', process.env.ADMIN_LOGIN)
      .first()
      .then(result => {
        if (result === null) {
          this.hash(process.env.ADMIN_PASSWORD)
            .then(hash => {
              userCouchdb.insert({
                'login': process.env.ADMIN_LOGIN,
                'password': hash,
                'name': 'Codeseven',
                'role': 'superadmin'
              })
            })
        }
      })
  },

  createConfigDoc () {
    return configCouchdb.find('config')
      .then(res => {
        console.log('ok', res._id)
      })
      .catch(() => {
        configCouchdb.insert({
          '_id': 'config'
        })
      })
  },

  async createDefaultRoles () {
    this.createAdminRole()
    this.createAtendeeRole()
    this.createSupervisorRole()
  },

  async createAtendeeRole () {
    await configCouchdb.where('name', 'atendente')
      .get()
      .then(result => {
        if (result.length === 0) {
          configCouchdb
            ._insertBulk([
              {
                'name': 'atendente',
                'label': 'Atendente',
                'permissions': ['dashboard.overview', 'events.index', 'events.details', 'events.download.presenter', 'events.print.terms',
                  'events.reports.download', 'customers.index', 'customer.detail', 'customers.create', 'customers.edit', 'customers.tickets',
                  'customers.lamps', 'tickets.print', 'documents.print', 'lamps.print', 'reports.index', 'tickets.downloadDoc',
                  'tickets.uploadImg', 'tickets.uploadDoc', 'tickets.checkin', 'tickets.details'],
                'collection': 'roles'
              }
            ])
        }
      })
  },

  async createSupervisorRole () {
    await configCouchdb.where('name', 'supervisor')
      .get()
      .then(result => {
        if (result.length === 0) {
          configCouchdb
            ._insertBulk([
              {
                'name': 'supervisor',
                'label': 'Supervisor',
                'permissions': ['dashboard.overview', 'events.index', 'events.create', 'events.details',
                  'events.lottery', 'events.download.presenter', 'events.link.stock', 'events.print.terms',
                  'events.edit', 'events.reports.download', 'events.download.documents', 'events.tickets.replacements',
                  'customers.index', 'customers.manage', 'customer.detail', 'customers.create', 'customers.edit', 'customers.tickets',
                  'customers.lamps', 'tickets.print', 'documents.print', 'lamps.print', 'stock.edit',
                  'stock.create', 'stock.index', 'tickets.energyMetering', 'tickets.downloadDoc',
                  'tickets.uploadImg', 'tickets.uploadDoc', 'tickets.checkin', 'tickets.details', 'reports.index',
                  'users.index', 'users.create', 'users.edit', 'manufacturers.index', 'manufacturers.create',
                  'manufacturers.edit'],
                'collection': 'roles'
              }
            ])
        }
      })
  },

  async createAdminRole () {
    await configCouchdb.where('name', 'concessionaria')
      .get()
      .then(result => {
        if (result.length === 0) {
          configCouchdb
            ._insertBulk([
              {
                'name': 'concessionaria',
                'label': 'Concessionária',
                'permissions': ['dashboard.overview', 'events.index', 'events.details', 'events.download.documents',
                  'events.reports.download', 'customers.index', 'reports.index', 'tickets.uploadDoc', 'tickets.downloadDoc'],
                'collection': 'roles'
              }
            ])
        }
      })
  },

  hash (password) {
    return new Promise((resolve, reject) => {
      hasher(password).hash(function (error, hash) {
        if (error) {
          reject(error)
        }
        resolve(hash)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/SetupService.js